import '../../assets/javascripts/react/components/AddToList';
